import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../StoraEnsoComponents/Button';
import { HOME } from "../../Routes";
import PageWrapper from '../Layout/pageWrapper';
import { Container } from '../Container';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem 0;
  height: 100vh;

  p {
    margin-bottom: 3rem;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
`;

function NotFoundPage () {
  return (
    <PageWrapper>
      <Container>
        <Content>
          <Title>404</Title>
          <p>Sorry - the page you are looking for can't be found!</p>
          <Link to={HOME}>
            <Button>Go to homepage</Button>
          </Link>
        </Content>
      </Container>
    </PageWrapper>
  );
}

export default NotFoundPage;